import {Component, OnInit, Input, Output, ViewEncapsulation} from '@angular/core';
import { EventEmitter } from '@angular/core';
import {SimulationSessionProvider} from '../../data/SimulationSessionProvider';
import {ModelsDataProvider} from '../../data/ModelsDataProvider';
import {SimulationSession} from '../../data/SimulationSession';
import {MatDialog} from '@angular/material/dialog';
import {AristoDialogComponent} from '../../aristo-dialog/aristo-dialog.component';
import {Router} from '@angular/router';
import {NewSessionDialogComponent} from '../../new-session-dialog/new-session-dialog.component';

@Component({
  selector: 'app-step1-litrage',
  templateUrl: './step1-litrage.component.html',
  styleUrls: ['./step1-litrage.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class Step1LitrageComponent implements OnInit {

  @Input()
  public simulationSession!: SimulationSession;
  @Output() simulationSessionChange: EventEmitter<SimulationSession> = new EventEmitter<SimulationSession>();
  @Output() leftButton: EventEmitter<any> = new EventEmitter<any>();
  @Output() rightButton: EventEmitter<any> = new EventEmitter<any>();
  public litrageLabels: string[] = [];
  litrage = '';

  constructor(private modelsDataProvider: ModelsDataProvider, public dialog: MatDialog, private router: Router,
              private simulationSessionProvider: SimulationSessionProvider) { }

  ngOnInit(): void {
    for (let modelGroup of this.modelsDataProvider.getModelsGroups()) {
      this.litrageLabels.push(modelGroup.label);
    }
  }

  saveLitrage() {
    this.simulationSessionChange.emit(this.simulationSession);
  }

  leftButtonClicked() {
      this.goHome();
  }

  rightButtonClicked() {
    if (this.isValid()) {
      this.rightButton.emit();
    }
  }

  public goHome() {
    const dialogRef = this.dialog.open(NewSessionDialogComponent);

    dialogRef.afterClosed().subscribe(result => {
      if (result && result === true){
        this.simulationSessionProvider.resetSimulationSession();
        this.router.navigate(['/home']);
      }
    });
  }

  isValid(): boolean {
    if (this.simulationSession.litrage && this.simulationSession.litrage.trim()) {
      return true;
    }
    else {
      this.dialog.open(AristoDialogComponent, { data: { dialogText: 'MESSAGES.ERRORS.LITRAGE_ERROR'}});
      return false;
    }
  }
}
